<template>
  <div class="mini-calendar__pager">
    <ul class="pagination-list" v-if="total > 0">
      <li class="pagination__control first" v-if="page > 1">
        <a href="#" @click.prevent="updateHandler(1)">
          <span class="visible-for-screen-readers">First Page</span>
        </a>
      </li>
      <li class="pagination__control prev" v-if="page > 1">
        <a href="#" @click.prevent="updateHandler(page - 1)">
          <span class="visible-for-screen-readers">Previous Page</span>
        </a>
      </li>
      <li
        class="pagination__page-numbers"
        v-for="pg in visiblePages"
        :key="pg"
        :class="{ 'pagination__page-number--current': pg === page }"
      >
        <a
          href="#"
          @click.prevent="updateHandler(pg)"
          :aria-current="pg === page ? 'page' : null"
        >
          {{ pg }}
        </a>
      </li>
      <li class="pagination__control next" v-if="page < getPages">
        <a href="#" @click.prevent="updateHandler(page + 1)">
          <span class="visible-for-screen-readers">Next Page</span>
        </a>
      </li>
      <li class="pagination__control last" v-if="page < getPages">
        <a href="#" @click.prevent="updateHandler(getPages)">
          <span class="visible-for-screen-readers">Last Page</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { DEFAULT_LIMIT } from "@/utils/config";
import { mapGetters, mapActions } from "vuex";
import { getFilteredEvents } from "./../api";
import moment from "moment";

export default {
  name: "MiniCalendarPager",
  props: {
    scroll: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      page_size: DEFAULT_LIMIT,
    };
  },
  methods: {
    updateHandler(page) {
      const searchBar = document.querySelector(".mini-calendar__search");
      if (searchBar) {
        const topOffset = searchBar.getBoundingClientRect().top + window.scrollY - 70;
        window.scrollTo({
          top: topOffset,
          behavior: "smooth",
        });
      }
      this.setLoading(true);
      this.setPage(page);
      const currentDate = moment().format("YYYY-MM-DD");
      const startDate = this.date_range.start || currentDate;
      const endDate = this.date_range.end || "";

      const searchTerm = this.search || "";
      const queryString = Object.entries(this.$store.state.selectedCategories || {})
        .flatMap(([key, terms]) => terms.map((term) => `${key}=${term}`))
        .join("&");

      const finalQueryString = queryString || "";
      getFilteredEvents(startDate, endDate, finalQueryString, page, searchTerm)
        .then((response) => {
          if (response) {
            let data = response.data ? response.data : [];
            this.setEventList({
              eventlist: data,
              total: response.query.total,
            });
          }
          this.setLoading(false);
        })
        .catch(() => {
          this.setLoading(false);
        });
    },
    ...mapActions(["setEventList", "setLoading", "setPage"]),
  },
  computed: {
    getPages() {
      return Math.ceil(this.total / DEFAULT_LIMIT);
    },
    visiblePages() {
      const range = [];
      const maxVisible = 5;
      const totalPages = this.getPages;

      if (totalPages <= maxVisible) {
        for (let i = 1; i <= totalPages; i++) {
          range.push(i);
        }
      } else {
        let start = Math.max(1, this.page - Math.floor(maxVisible / 2));
        let end = start + maxVisible - 1;

        if (end > totalPages) {
          end = totalPages;
          start = totalPages - maxVisible + 1;
        }

        for (let i = start; i <= end; i++) {
          range.push(i);
        }
      }

      return range;
    },
    ...mapGetters(["total", "page", "search", "date_range", "filter"]),
  },
};
</script>
